import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const NewsStatus = ({ value }) => {
    const { t } = useTranslation();

    return (
        <Typography style={{ color: value ? 'inherit' : 'red', fontWeight: 500 }}>
            {value ? t('news.read') : t('news.unread')}
        </Typography>
    );
};

export default NewsStatus;
